<script>
export default {
  name: "PromptComponent",
  props: {
    documentPrompt: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="prompt">
    <div><b>Потребуются документы:</b></div>
    <div v-html="documentPrompt"></div>
  </div>
</template>

<style scoped>

</style>
